import pics from "./img.ts";
let idx = 0;

let loaded: Array<boolean> = new Array(pics.length).fill(false);

let autoFade = () => {
  if (!loaded[idx]) {
    let carouselElem = document.createElement("div");

    // imageElem.style.display = "none";
    carouselElem.classList =
      "w-full flex flex-col justify-center items-center overflow-auto h-128 hidden";
    let elemTxt = `
<!-- Full-width images with number and caption text -->

    <!-- <div class="">${idx + 1} / ${pics.length}</div> -->
    <img src=${pics[idx].toString()} class="w-full h-full object-contain rounded-lg">
`;

    carouselElem.innerHTML = elemTxt;

    document.querySelector("#carousel")!.appendChild(carouselElem);
    loaded[idx] = true;
  }
  let carouselContainer = document.querySelector("#carousel")!;
  for (let elem of carouselContainer.children) {
    elem.classList.remove("hidden");
    elem.classList.add("hidden");
  }
  carouselContainer.children[idx].classList.remove("hidden");
  idx++;
  idx = idx % pics.length;
};

let init = () => {
  autoFade();
  setInterval(autoFade, 2000);
};
export { init };
